import loadable from '@loadable/component';

import { CenterLoader } from 'components/loader';

export const AsyncLogin = loadable(
  () => import(/* webpackChunkName: "AsyncLogin" */ 'components/Auth/Login')
);
export const AsyncSSOLogin = loadable(
  () => import(/* webpackChunkName: "AsyncSSOLogin" */ 'components/Auth/SSOLogin')
);
export const AsyncLinkAccount = loadable(
  () => import(/* webpackChunkName: "LinkAccount" */ 'components/Auth/LinkAccount')
);
export const AsyncDisable2FA = loadable(
  () => import(/* webpackChunkName: "AsyncDisable2FA" */ 'components/Disable2faFaceAuth')
);
export const AsyncUniversalSearchMobile = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncUniversalSearchMobile" */ 'components/primaryHeader/partials/universalSearch'
    )
);
export const AsyncSignup = loadable(
  () => import(/* webpackChunkName: "AsyncSignup" */ 'components/Auth/Signup')
);

export const AsyncAccount = loadable(
  () => import(/* webpackChunkName: "AsyncAccount" */ 'components/account/account'),
  {
    fallback: <CenterLoader />,
  }
);
export const AsyncTradingView = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncTradingView" */ 'components/chart/LoadTradingviewContainer'
    )
);
export const AsyncTradingViewChartNewTab = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncTradingViewChartNewTab", webpackPrefetch: true */ 'components/chart/TradingChartContainerNewTab'
    )
);

export const AsyncOffers = loadable(
  () => import(/* webpackChunkName: "AsyncOffers" */ 'containers/offers')
);
export const AsyncOptionsLeaderBoard = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncOptionsLeaderBoard" */ 'components/OptionsLeaderBoard/OptionLeaderBoard'
    )
);
export const AsyncWithdrawalConfirmation = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncWithdrawalConfirmation" */ 'components/withdrawal_confirmation'
    )
);
export const AsyncReferences = loadable(
  () => import(/* webpackChunkName: "AsyncReferences" */ 'components/references')
);
export const AsyncApi = loadable(
  () => import(/* webpackChunkName: "AsyncApi" */ 'components/api')
);
export const AsyncSignupVerify = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncSignupVerify" */ 'components/Auth/SignupVerification'
    )
);
export const AsyncForgotPassword = loadable(
  () =>
    import(/* webpackChunkName: "AsyncForgotPassword" */ 'components/Auth/ForgotPassword')
);
export const AsyncResetPassword = loadable(
  () =>
    import(/* webpackChunkName: "AsyncResetPassword" */ 'components/Auth/ResetPassword')
);

export const AsyncReferral = loadable(
  () => import(/* webpackChunkName: "AsyncReferral" */ 'containers/referral')
);

export const AsyncPortfolio = loadable(
  () => import(/* webpackChunkName: "AsyncPortfolio" */ 'components/portfolio')
);
export const AsyncAppDrawer = loadable(
  () => import(/* webpackChunkName: "AsyncAppDrawer" */ 'components/appDrawer')
);

export const AsyncExpiredFuturesPage = loadable(
  () =>
    import(/* webpackChunkName: "AsyncExpiredFuturesPage" */ 'containers/expiredProducts')
);

export const AsyncBellAlerts = loadable(
  () => import(/* webpackChunkName: "AsyncBellAlerts" */ 'components/bellAlerts')
);

export const AsyncOptionsAnalyticsDashboard = loadable(
  () =>
    import(
      /* webpackChunkName: 'OptionsAnalyticsDashboard' */ 'containers/OptionsAnalyticsDashboard'
    )
);

export const AsyncUpdatePassword = loadable(
  () =>
    import(/* webpackChunkName: "AsyncUpdatePassword" */ 'components/Auth/UpdatePassword')
);

// Right way would be to list them in storybook
// export const IconsList = loadable(() =>
// import(/* webpackChunkName: "IconsList" */ 'components/IconList/IconList')

export const AsyncOptionsLeaderBoardPage = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncOptionLeaderBoardPage" */ 'components/OptionsLeaderBoard/OptionLeaderBoardPage'
    )
);

export const AsyncTradeHistoryPage = loadable(
  () => import(/* webpackChunkName: "AsyncTradeHistoryPage" */ 'components/TradeHistory')
);

export const AsyncMobileRiskViewAll = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncMobileRiskViewAll" */ 'components/MobileHolding/components/MobileRiskViewAll'
    )
);

export const AsyncExpiredProductCharts = loadable(
  () =>
    import(
      /* webpackChunkName: "AsyncExpiredProductCharts" */ 'components/expiredFutures/expiredProductChart'
    )
);

export const AppFooter = loadable(
  () =>
    import(
      /* webpackChunkName: "AppFooter" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/appFooter'
    )
);

export const ConnectionStatusStrip = loadable(
  () =>
    import(
      /* webpackChunkName: "ConnectionStatusStrip" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/ConnectionStatusStrip'
    )
);

export const MobileSideMenu = loadable(
  () =>
    import(
      /* webpackChunkName: "MobileSideMenu" */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/primaryHeaderMobile/partials/mobileSideMenu'
    )
);

export const MobileQuickLinks = loadable(
  () =>
    import(
      /* webpackChunkName: "MobileQuickLinks" */ /* webpackMode: "lazy" */ 'components/markets/partials/quickLinks'
    )
);

export const NotFound = loadable(
  () =>
    import(
      /* webpackChunkName: "NotFound" */ /* webpackMode: "lazy" */ 'components/notFound'
    )
);

export const KycReduceOnlyModal = loadable(
  () =>
    import(
      /* webpackChunkName: "KycReduceOnlyModal" */ /* webpackMode: "lazy" */ 'components/KycReduceOnlyModal'
    )
);

export const KycRefreshModal = loadable(
  () =>
    import(
      /* webpackChunkName: "KycRefreshModal" */ /* webpackMode: "lazy" */ 'components/kycRefreshModal'
    )
);

export const Maintenance = loadable(
  () =>
    import(
      /* webpackChunkName: "Maintenance " */ /* webpackMode: "lazy" */ /* webpackPrefetch: true */ 'components/maintenance'
    )
);

export const DegradedModeNotifyView = loadable(
  () =>
    import(
      /* webpackChunkName: "DegradedModeNotifyView" */ /* webpackMode: "lazy" */ 'components/DegradedModeNotifyView'
    )
);

export const DegradedManagePositionPage = loadable(
  () =>
    import(
      /* webpackChunkName: "DegradedManagePositionPage" */ /* webpackMode: "lazy" */ 'components/DegradedManagePositionPage'
    )
);

export const AsyncRecoverUserAccount = loadable(
  () =>
    import(
      /* webpackChunkName: "RecoverUserAccount" */ /* webpackMode: "lazy" */ 'components/RecoverUserAccount'
    )
);

export const AsyncForgotEmailId = loadable(
  () =>
    import(
      /* webpackChunkName: "ForgotEmailId" */ /* webpackMode: "lazy" */ 'components/ForgotEmailId/ForgotEmailId'
    )
);

export const AysncTransferFundsNative = loadable(
  () =>
    import(
      /* webpackChunkName: "TransferFundsNative" */ /* webpackMode: "lazy" */ 'components/sub_account/transferFund.native.route'
    )
);

export const AsyncPositionAnalytics = loadable(
  () =>
    import(
      /* webpackChunkName: "PositionAnalytics" */ /* webpackMode: "lazy" */ 'components/PositionAnalytics/PositionAnalytics'
    )
);

export const AsyncPriceAlerts = loadable(
  () =>
    import(
      /* webpackChunkName: "PriceAlerts" */ /* webpackMode: "lazy" */ 'components/tradePriceAlerts'
    )
);

export const AsyncAlgoMarketplace = loadable(
  () =>
    import(
      /* webpackChunkName: "AlgoMarketplace" */ /* webpackMode: "lazy" */ 'components/AlgoMarketplace'
    )
);

export const AsyncCalculatorPage = loadable(
  () =>
    import(
      /* webpackChunkName: "CalculatorPage" */ /* webpackMode: "lazy" */ 'components/calculator/CalculatorPage'
    )
);
